import { Container } from "@mui/material";
import Layout from "components/Layout";
import ResetPasswordWithToken from "components/ResetPasswordWithToken";

export default function ResetPasswordWithTokenPage() {
  return (
    <Layout>
      <Container component="main" maxWidth="xs">
        <ResetPasswordWithToken />
      </Container>
    </Layout>
  );
}
